import React from 'react'
import { createStackNavigator } from '@react-navigation/stack'

import { LogisticsRoutes } from '../types'
import {
  ConsumptionSuccess,
  FinalPhotoMeter,
  FinalPhotoRod,
  FuelConsumption,
  FuelReceptions,
  InitialPhotoMeter,
  InitialPhotoRod,
  ManualOrder,
  MeterLog,
  SummaryLogistic,
  TestResult,
  VoucherLog,
  VoucherPhoto,
} from '../../modules'
import { Records } from '../../modules/Logistics/FuelReceptions/pages/Records'

const Stack = createStackNavigator<LogisticsRoutes>()

export const LogisticsStack = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
        gestureEnabled: false,
      }}
    >
      <Stack.Screen name='FuelReception' component={FuelReceptions} />
      <Stack.Screen name='FuelConsumption' component={FuelConsumption} />
      <Stack.Screen name='ManualOrder' component={ManualOrder} />
      <Stack.Screen name='FinalPhotoRod' component={FinalPhotoRod} />
      <Stack.Screen name='InitialPhotoRod' component={InitialPhotoRod} />
      <Stack.Screen name='TestResults' component={TestResult} />
      <Stack.Screen name='FinalPhotoMeter' component={FinalPhotoMeter} />
      <Stack.Screen name='InitialPhotoMeter' component={InitialPhotoMeter} />
      <Stack.Screen name='MeterLog' component={MeterLog} />
      <Stack.Screen name='VoucherPhoto' component={VoucherPhoto} />
      <Stack.Screen name='VoucherLog' component={VoucherLog} />
      <Stack.Screen name='Summary' component={SummaryLogistic} />
      <Stack.Screen name='Records' component={Records} />
      <Stack.Screen name='Success' component={ConsumptionSuccess} />
    </Stack.Navigator>
  )
}
